import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitlePages: {
		id: 'project-pages.page-title-pages',
		defaultMessage: 'Pages',
		description: 'The Pages page title which appears on tab/browser label',
	},
});
